import * as React from 'react';
export var UiKitThemeContext = /*#__PURE__*/React.createContext({
  theme: 'light'
});
export function useUiKitThemeContext() {
  return React.useContext(UiKitThemeContext);
}